import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { memo, useState } from "react";
import { WEIGHT_BOLD } from "@hl/base-components/lib/theme/typography";
import { Anchor, Stack, Text } from "@mantine/core";
import { IconArrowRightBar } from "@tabler/icons";
import ReactMarkdown from "react-markdown";
import gfm from "remark-gfm";
const DescriptionMarkdown = ({ description, hasExpand, numChars, disableVideos, lineClamp, ...rest }) => {
    var _a;
    const enableExpanded = description.length > (numChars !== null && numChars !== void 0 ? numChars : 0);
    const [expanded, setExpanded] = useState(!hasExpand);
    const descriptionClean = (_a = description === null || description === void 0 ? void 0 : description.replace(/\\n/g, "\n")) !== null && _a !== void 0 ? _a : "";
    const finalText = expanded || !enableExpanded
        ? descriptionClean
        : `${descriptionClean.slice(0, numChars)}...`;
    return (_jsxs(Stack, { spacing: 0, children: [_jsx(Text, { size: "sm", ...rest, onClick: () => hasExpand && enableExpanded ? setExpanded((exp) => !exp) : undefined, lineClamp: lineClamp, children: _jsx(ReactMarkdown, { remarkPlugins: [gfm], components: {
                        a: (props) => (_jsx(Anchor, { ...props, sx: {
                                fontSize: rest.size || 14,
                                textDecoration: "underline",
                                wordBreak: "break-word",
                                textUnderlineOffset: 3,
                            } })),
                        img: (props) => {
                            var _a, _b;
                            if (disableVideos) {
                                return null;
                            }
                            if ((_a = props.src) === null || _a === void 0 ? void 0 : _a.startsWith("https://www.youtube.com/embed/")) {
                                return (_jsx("iframe", { width: "100%", style: { aspectRatio: "16/9" }, src: props.src, title: (_b = props.alt) !== null && _b !== void 0 ? _b : "YouTube embed", frameBorder: "0", allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share", referrerPolicy: "strict-origin-when-cross-origin", allowFullScreen: true }));
                            }
                            return _jsx("img", { ...props, style: { maxWidth: "100%" } });
                        },
                    }, children: finalText }) }), !expanded && enableExpanded && (_jsxs(Text, { onClick: () => setExpanded(true), fw: WEIGHT_BOLD, size: "sm", sx: {
                    alignItems: "center",
                    display: "flex",
                    cursor: "pointer",
                    width: "fit-content",
                }, children: ["Read more\u00A0", _jsx(IconArrowRightBar, { width: 16 })] }))] }));
};
export default memo(DescriptionMarkdown);
